<template>
  <div class="news-feed-container">
    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 左侧用户选择 -->
      <UserListSidebar :selected-user="selectedUser" :show-batch-operation="true" :multi-select="isBatchMode"
        :selected-user-ids="selectedUserIds" title="用户列表" @select-user="selectUser"
        @update:selectedUserIds="handleSelectedUserIdsChange" @selection-change="handleSelectionChange" />
      <!-- 右侧内容区域 -->
      <div class="content-area">
        <!-- 标签页和创建按钮 -->
        <div class="content-tabs">
          <div class="tabs-left">
            <div v-for="tab in tabs" :key="tab.key" :class="['tab-item', { active: activeTab === tab.key }]"
              @click="handleTabChange(tab.key)" @contextmenu="handleTabRightClick(tab.key, $event)">
              <span class="tab-label">{{ tab.label }}</span>
            </div>
          </div>
          <div class="tabs-right">
            <!-- 批量操作按钮 -->
            <div v-if="isBatchMode" class="batch-actions">
              <button class="btn btn-primary batch-create-btn" :class="{ disabled: selectedUserIds.length === 0 }"
                :disabled="selectedUserIds.length === 0" @click="
                  selectedUserIds.length > 0 && (showBatchCreateModal = true)
                  " :title="selectedUserIds.length === 0 ? '请先选择用户' : '批量创建'
                    ">
                <div class="btn-icon-wrapper">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                  </svg>
                </div>
                <span class="btn-text">批量创建
                  {{
                    selectedUserIds.length > 0
                      ? `(${selectedUserIds.length})`
                      : ''
                  }}</span>
                <div class="btn-ripple"></div>
              </button>
              <button class="btn btn-secondary batch-settings-btn" :class="{ disabled: selectedUserIds.length === 0 }"
                :disabled="selectedUserIds.length === 0" @click="
                  selectedUserIds.length > 0 && (showBatchSettingsModal = true)
                  " :title="selectedUserIds.length === 0 ? '请先选择用户' : '批量设置'
                    ">
                <div class="btn-icon-wrapper">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path
                      d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z" />
                  </svg>
                </div>
                <span class="btn-text">批量设置
                  {{
                    selectedUserIds.length > 0
                      ? `(${selectedUserIds.length})`
                      : ''
                  }}</span>
                <div class="btn-ripple"></div>
              </button>
            </div>

            <!-- 退出批量模式按钮 -->
            <button v-if="isBatchMode" class="btn btn-secondary exit-batch-btn" @click="exitBatchMode">
              <div class="btn-icon-wrapper">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                </svg>
              </div>
              <span class="btn-text">退出批量</span>
              <div class="btn-ripple"></div>
            </button>

            <!-- 普通模式下的按钮 -->
            <div v-if="!isBatchMode" class="normal-actions">
              <button class="btn btn-secondary whitelist-btn" @click="showWhitelistModal = true">
                <div class="btn-icon-wrapper">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path
                      d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                </div>
                <span class="btn-text">白名单</span>
                <div class="btn-ripple"></div>
              </button>
              <button class="btn btn-primary create-btn" :class="{ disabled: !canCreateContent }"
                :disabled="!canCreateContent" @click="showCreateModal = true" :title="getCreateButtonTooltip()">
                <div class="btn-icon-wrapper">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                  </svg>
                </div>
                <span class="btn-text">创建</span>
                <div class="btn-ripple"></div>
              </button>
              <button class="btn btn-secondary settings-btn" @click="showSettingsModal = true">
                <div class="btn-icon-wrapper">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path
                      d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z" />
                  </svg>
                </div>
                <span class="btn-text">设置</span>
                <div class="btn-ripple"></div>
              </button>
            </div>
            <!-- 批量设置按钮 -->
            <button v-if="!isBatchMode" class="btn btn-secondary batch-mode-btn" @click="enterBatchMode">
              <div class="btn-icon-wrapper">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2zm0-4H7V7h10v2z" />
                </svg>
              </div>
              <span class="btn-text">批量操作</span>
              <div class="btn-ripple"></div>
            </button>
          </div>
        </div>

        <!-- 内容区域 -->
        <div class="content-content">
          <div class="schedule-description flex row middle between">
            <div v-if="activeTab === 'message' && userMassSetting.message" class="description-text">
              <i class="el-icon-time"></i>
              每分钟给 {{ userMassSetting.messageSendUserNum || 20 }} 个
              {{ userMassSetting.messageUnSendUserTime || 4 }}
              小时没聊天的在线用户发送消息，持续
              {{ messageIntervalTimeHours }} 小时
            </div>
            <div v-else-if="activeTab === 'email' && userMassSetting.mail" class="description-text">
              <i class="el-icon-time"></i>
              每隔 {{ mailIntervalTimeHours }} 小时给
              {{ userMassSetting.mailSendUserNum || 2 }} 个
              {{ userMassSetting.mailUnSendUserTime || 6 }}
              小时没聊天的离线用户发送邮件
            </div>
            <div v-else class="description-text no-template">
              <i class="el-icon-warning"></i>
              请先设置{{ activeTab === 'message' ? '消息' : '邮件' }}模板
            </div>
            <button class="btn btn-danger batch-delete-btn" :class="{ disabled: selectedTemplates.length === 0 }"
              :disabled="selectedTemplates.length === 0"
              @click="selectedTemplates.length > 0 && showBatchDeleteConfirm()" :title="selectedTemplates.length === 0 ? '请先选择模板' : '批量删除'
                ">
              <div class="btn-icon-wrapper">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
                </svg>
              </div>
              <span class="btn-text">批量删除
                {{
                  selectedTemplates.length > 0
                    ? `(${selectedTemplates.length})`
                    : ''
                }}</span>
              <div class="btn-ripple"></div>
            </button>
          </div>
          <!-- 表格列表 -->
          <div v-if="currentList.length > 0" class="table-container" v-loading="isLoadingTemplate"
            element-loading-text="正在加载模板数据...">
            <el-table :data="currentList" height="calc(100vh - 256px)" @row-click="selectItem"
              :row-class-name="getRowClassName" style="width: 100%" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="60" align="center" header-align="center">
              </el-table-column>
              <el-table-column prop="index" label="序号" width="60" align="center">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column prop="content" label="内容" min-width="400">
                <template slot-scope="scope">
                  <div class="content-text">{{ scope.row.content }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="attachmentsNum" label="附件" width="80" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.attachmentsNum > 0" class="attachment-count"
                    @click.stop="showAttachments(scope.row)">
                    <i class="el-icon-paperclip attachment-icon"></i>
                    {{ scope.row.attachmentsNum }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="sendInterval" label="间隔(分钟)" width="100" align="center">
                <template slot-scope="scope">
                  <div class="interval-display">{{ scope.row.sendInterval }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="totalCount" label="发送次数" width="80" align="center">
                <template slot-scope="scope">
                  <div class="value-badge">{{ scope.row.totalCount }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="failCount" label="失败" width="60" align="center">
                <template slot-scope="scope">
                  <div class="value-badge fail">{{ scope.row.failCount }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="successCount" label="成功" width="60" align="center">
                <template slot-scope="scope">
                  <div class="value-badge success">{{ scope.row.successCount }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="发送时间" width="120">
                <template slot-scope="scope">
                  <div class="countdown-display" :class="getCountdownClass(scope.row)">
                    <div v-if="isCountdown(scope.row)" class="countdown-timer">
                      <i class="el-icon-time countdown-icon"></i>
                      <span class="countdown-text">{{ getStatusDisplay(scope.row) }}</span>
                    </div>
                    <div v-else class="status-text">
                      {{ getStatusDisplay(scope.row) }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="sendStatus" label="发送状态" width="80" align="center">
                <template slot-scope="scope">
                  <div class="send-status-badge"
                    :class="getSendStatusClass(scope.row.sendStatus, scope.row.preSendTime)">
                    {{ getSendStatusText(scope.row.sendStatus, scope.row.preSendTime) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope">
                  <div class="action-buttons">
                    <button class="action-btn edit-btn" :class="{ 'disabled': isEditDisabled(scope.row) }"
                      :disabled="isEditDisabled(scope.row)"
                      @click.stop="!isEditDisabled(scope.row) && openEditModal(scope.row)"
                      :title="isEditDisabled(scope.row) ? '发送完成状态不可编辑' : '编辑'">
                      <i class="el-icon-edit"></i>
                    </button>
                    <button class="action-btn delete-btn" @click.stop="showDeleteConfirm(scope.row)" title="删除">
                      <i class="el-icon-delete"></i>
                    </button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 空状态 -->
          <div v-else class="empty-state" v-loading="isLoadingTemplate" element-loading-text="正在加载模板数据...">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" />
            </svg>
            <p v-if="!isLoadingTemplate">暂无{{ activeTab === 'message' ? '消息' : '邮件' }}数据</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 创建内容模态框 -->
    <CreateContentModal :visible="showCreateModal" @close="showCreateModal = false" @success="handleCreateSuccess"
      @error="handleError" :userMassSetting="userMassSetting" :selectedUser="selectedUser" />

    <!-- 编辑内容模态框 -->
    <CreateContentModal ref="editModal" :visible="showEditModal" @close="showEditModal = false"
      @success="handleEditSuccess" @error="handleError" :userMassSetting="userMassSetting" :selectedUser="selectedUser"
      :editData="itemToEdit" />

    <!-- 设置模态框 -->
    <SettingsModal :visible="showSettingsModal" @close="showSettingsModal = false" @success="handleSettingsSuccess"
      @error="handleSettingsError" :activeTab="activeTab"
      :selectedUser="{ ...selectedUser, userMassSetting: userMassSetting }" />

    <!-- 附件预览弹窗 -->
    <div v-if="showAttachmentModal" class="attachment-modal-overlay" @click="closeAttachmentModal">
      <div class="attachment-modal" @click.stop>
        <div class="modal-header">
          <h3>附件预览</h3>
          <button class="close-btn" @click="closeAttachmentModal">
            <i class="el-icon-close"></i>
          </button>
        </div>
        <div class="modal-content">
          <div class="attachment-grid">
            <div v-for="(attachment, index) in currentAttachments" :key="index" class="attachment-item">
              <div class="attachment-preview">
                <img v-if="attachment.type === 'image'" :src="attachment.url" :alt="attachment.name"
                  @click="previewAttachment(attachment)" />
                <video v-else-if="attachment.type === 'video'" :src="attachment.url" controls
                  @click="previewAttachment(attachment)" />
              </div>
              <div class="attachment-name">{{ attachment.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 删除确认弹窗 -->
    <div v-if="showDeleteModal" class="delete-modal-overlay" @click="closeDeleteModal">
      <div class="delete-modal" @click.stop>
        <div class="modal-header">
          <h3>确认删除</h3>
          <button class="close-btn" @click="closeDeleteModal">
            <i class="el-icon-close"></i>
          </button>
        </div>
        <div class="modal-content">
          <div class="delete-content">
            <div class="warning-icon">
              <i class="el-icon-warning"></i>
            </div>
            <div class="delete-message">
              <p>
                确定要删除这条{{
                  itemToDelete?.type === 'message' ? '消息' : '邮件'
                }}吗？
              </p>
              <p class="content-preview">{{ itemToDelete?.content }}</p>
            </div>
            <div class="delete-actions">
              <button class="cancel-btn" @click="closeDeleteModal" :disabled="isDeleting">取消</button>
              <button class="confirm-btn" @click="confirmDelete" :disabled="isDeleting">
                <svg v-if="!isDeleting" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
                </svg>
                <svg v-if="isDeleting" class="loading-spinner" width="16" height="16" viewBox="0 0 24 24"
                  fill="currentColor">
                  <path d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z">
                    <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s"
                      from="0 12 12" to="360 12 12" repeatCount="indefinite" />
                  </path>
                </svg>
                <span>{{ isDeleting ? '删除中...' : '确认删除' }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 详情弹窗 -->
    <div v-if="showDetailModal" class="detail-modal-overlay" @click="closeDetailModal">
      <div class="detail-modal" @click.stop>
        <div class="modal-header">
          <h3>
            {{ currentDetailItem?.type === 'message' ? '消息' : '邮件' }}详情
          </h3>
          <button class="close-btn" @click="closeDetailModal">
            <i class="el-icon-close"></i>
          </button>
        </div>
        <div class="modal-content">
          <div class="detail-content">
            <!-- 内容详情 -->
            <div class="detail-section">
              <h4 class="section-title">
                <i class="el-icon-document"></i>
                内容详情
              </h4>
              <div class="content-detail">
                <div class="content-text-full">
                  {{ currentDetailItem?.content }}
                </div>
              </div>
            </div>
            <!-- 附件详情 -->
            <div v-if="currentDetailItem?.attachmentsNum > 0" class="detail-section">
              <h4 class="section-title">
                <i class="el-icon-paperclip"></i>
                附件预览 ({{ currentDetailItem.attachmentsNum }}个)
              </h4>
              <!-- 图片列表 -->
              <div v-if="
                currentDetailItem.imageList &&
                currentDetailItem.imageList.length > 0
              " class="attachment-section">
                <h5 class="attachment-section-title">
                  <i class="el-icon-picture"></i>
                  图片 ({{ currentDetailItem.imageList.length }}张)
                </h5>
                <div class="attachment-detail">
                  <div v-for="(imageUrl, index) in currentDetailItem.imageList" :key="`img-${index}`"
                    class="attachment-item-detail">
                    <div class="attachment-preview-detail">
                      <img :src="imageUrl" :alt="`图片 ${index + 1}`" />
                    </div>
                  </div>
                </div>
              </div>
              <!-- 视频列表 -->
              <div v-if="
                currentDetailItem.videoList &&
                currentDetailItem.videoList.length > 0
              " class="attachment-section">
                <h5 class="attachment-section-title">
                  <i class="el-icon-video-camera"></i>
                  视频 ({{ currentDetailItem.videoList.length }}个)
                </h5>
                <div class="attachment-detail">
                  <div v-for="(videoUrl, index) in currentDetailItem.videoList" :key="`vid-${index}`"
                    class="attachment-item-detail">
                    <div class="attachment-preview-detail">
                      <video :src="videoUrl" controls />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 白名单弹窗组件 -->
    <WhitelistModal :visible="showWhitelistModal" :selectedUser="selectedUser" @close="closeWhitelistModal" />

    <!-- 批量设置弹窗 -->
    <BatchSettingsModal :visible="showBatchSettingsModal" :selectedUserIds="selectedUserIds" :activeTab="activeTab"
      @close="showBatchSettingsModal = false" @success="handleBatchSettingsSuccess" @error="handleBatchSettingsError" />

    <!-- 批量创建弹窗 -->
    <BatchCreateModal :visible="showBatchCreateModal" :selectedUserIds="selectedUserIds" :activeTab="activeTab"
      @close="showBatchCreateModal = false" @success="handleBatchCreateSuccess" @error="handleBatchCreateError" />

    <!-- 批量删除确认弹窗 -->
    <div v-if="showBatchDeleteModal" class="delete-modal-overlay" @click="closeBatchDeleteModal">
      <div class="delete-modal" @click.stop>
        <div class="modal-header">
          <h3>确认批量删除</h3>
          <button class="close-btn" @click="closeBatchDeleteModal">
            <i class="el-icon-close"></i>
          </button>
        </div>
        <div class="modal-content">
          <div class="delete-content">
            <div class="warning-icon">
              <i class="el-icon-warning"></i>
            </div>
            <div class="delete-message">
              <p>
                确定要删除选中的 {{ selectedTemplates.length }} 个{{
                  activeTab === 'message' ? '消息' : '邮件'
                }}模板吗？
              </p>
              <p class="delete-warning">
                此操作不可撤销，删除后模板将无法恢复。
              </p>
            </div>
            <div class="delete-actions">
              <button class="cancel-btn" @click="closeBatchDeleteModal" :disabled="isBatchDeleting">
                取消
              </button>
              <button class="confirm-btn" @click="confirmBatchDelete" :disabled="isBatchDeleting">
                <svg v-if="!isBatchDeleting" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
                </svg>
                <svg v-if="isBatchDeleting" class="loading-spinner" width="16" height="16" viewBox="0 0 24 24"
                  fill="currentColor">
                  <path d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z">
                    <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s"
                      from="0 12 12" to="360 12 12" repeatCount="indefinite" />
                  </path>
                </svg>
                <span>{{ isBatchDeleting ? '删除中...' : '确认删除' }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserListSidebar from '@/components/UserListSidebar.vue';
import CreateContentModal from './components/CreateContentModal.vue';
import SettingsModal from './components/SettingsModal.vue';
import WhitelistModal from './components/WhitelistModal.vue';
import BatchSettingsModal from './components/BatchSettingsModal.vue';
import BatchCreateModal from './components/BatchCreateModal.vue';
import {
  getUserIsMassSetting,
  updateMassTask,
  addMassTask,
  getTaskTemplate,
  removeTaskTemplate,
} from '@/api/talkytimes/masSending';

export default {
  name: 'masSending',
  components: {
    UserListSidebar,
    CreateContentModal,
    SettingsModal,
    WhitelistModal,
    BatchSettingsModal,
    BatchCreateModal,
  },
  data() {
    return {
      activeTab: 'message',
      selectedUser: {},
      postsList: [],
      tabs: [
        { key: 'message', label: '消息' },
        { key: 'email', label: '邮件' },
      ],
      showCreateModal: false,
      showSettingsModal: false,
      showWhitelistModal: false,
      selectedItem: null, // 选中的列表项
      showAttachmentModal: false, // 附件弹窗
      currentAttachments: [], // 当前显示的附件列表
      showDeleteModal: false, // 删除确认弹窗
      itemToDelete: null, // 要删除的项目
      showDetailModal: false, // 详情弹窗
      currentDetailItem: null, // 当前详情项目
      showEditModal: false, // 编辑模态框
      itemToEdit: null, // 要编辑的项目
      // 用户设置状态
      userMassSetting: {
        message: false,
        mail: false,
        messageJobId: null,
        mailJobId: null,
        // 消息相关设置
        messageIntervalTime: 0,
        messageSendUserNum: 0,
        messageUnSendUserTime: 0,
        messageStatus: 0,
        // 邮件相关设置
        mailIntervalTime: 0,
        mailSendUserNum: 0,
        mailUnSendUserTime: 0,
        mailStatus: 0,
      },
      // 新增列表数据
      messageList: [],
      emailList: [],
      selectedUserIds: [], // 选中的用户ID列表
      showBatchSettingsModal: false, // 批量设置模态框
      showBatchCreateModal: false, // 批量创建模态框
      isBatchMode: false, // 是否处于批量模式
      selectedTemplates: [], // 选中的模板ID列表
      showBatchDeleteModal: false, // 批量删除确认弹窗
      isDeleting: false, // 单个删除loading状态
      isBatchDeleting: false, // 批量删除loading状态
      isLoadingTemplate: false, // 获取模板数据loading状态
    };
  },
  computed: {
    // 根据当前激活的标签页返回对应的列表
    currentList() {
      return this.activeTab === 'message' ? this.messageList : this.emailList;
    },
    // 监听用户列表变化
    accountList() {
      return this.$store.state.accountList?.accountList || [];
    },
    // 判断是否可以创建内容
    canCreateContent() {
      if (!this.selectedUser.id) return false;

      // 根据当前激活的标签页检查对应的模板
      if (this.activeTab === 'message') {
        return this.userMassSetting.message;
      } else if (this.activeTab === 'email') {
        return this.userMassSetting.mail;
      }
      return false;
    },
    // 将分钟转换为小时显示
    messageIntervalTimeHours() {
      const minutes = this.userMassSetting.messageIntervalTime || 0;
      return (minutes / 60).toFixed(1);
    },
    // 将分钟转换为小时显示
    mailIntervalTimeHours() {
      const minutes = this.userMassSetting.mailIntervalTime || 0;
      return (minutes / 60).toFixed(1);
    },
  },
  watch: {
    // 监听用户列表变化，当有数据且没有选中用户时，自动选择第一个
    accountList: {
      handler(newList) {
        if (newList.length > 0 && !this.selectedUser.id) {
          this.selectFirstUser();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // 启动倒计时定时器
    this.startCountdown();
    
    // 第一次进入页面时，确保触发用户选择
    this.initUserSelection();
  },
  // keep-alive 组件激活时调用（从其他页面切换回来时）
  activated() {
    // 每次页面激活时，确保触发用户选择
    this.initUserSelection();
  },
  beforeDestroy() {
    // 清理定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
  methods: {
    // 初始化用户选择（每次进入页面时调用）
    initUserSelection() {
      this.$nextTick(() => {
        // 如果用户列表有数据，确保选择第一个用户并触发选择事件
        if (this.accountList.length > 0) {
          const firstUser = this.accountList[0];
          // 无论当前是否已选中用户，都重新触发一次选择，确保 activeUser 被正确设置到 localStorage
          this.selectUser(firstUser);
        }
      });
    },
    // 解析图片URL列表
    getImageUrls(item) {
      if (!item.imagesUrl) return [];

      // 按逗号分割图片URL
      const urls = item.imagesUrl.split(',').filter((url) => url.trim());
      console.log('urls::::::::::::', urls);
      // 过滤掉空字符串和无效URL
      return urls
        .filter((url) => {
          const trimmedUrl = url.trim();
          return (
            trimmedUrl &&
            (trimmedUrl.startsWith('http') || trimmedUrl.match(/^\d+$/))
          );
        })
        .map((url) => {
          const trimmedUrl = url.trim();
          // 如果是数字ID，需要转换为完整的URL
          if (trimmedUrl.match(/^\d+$/)) {
            // 这里可以根据实际需求构建完整的图片URL
            // 暂时返回原值，您可以根据实际的图片服务URL格式进行调整
            return `https://example.com/images/${trimmedUrl}.jpg`; // 请根据实际情况修改
          }
          return trimmedUrl;
        });
    },
    async selectUser(user) {
      this.selectedUser = user;

      // 设置activeToken
      if (user.pdToken) {
        localStorage.setItem('activeUser', JSON.stringify(user));
        console.log('设置activeUser:', user);
      }

      // 清空选中的模板列表
      this.selectedTemplates = [];

      // 调用接口检查用户设置状态
      await this.checkUserMassSetting(user.id);

      // 保持当前tabs选中项不变，不调用setDefaultActiveTabWithoutLoad()
    },
    // 选择第一个用户作为默认选择
    selectFirstUser() {
      if (this.accountList.length > 0) {
        // 选择第一个用户
        this.selectedUser = this.accountList[0];
        console.log('默认选择第一个用户:', this.selectedUser);

        // 设置activeToken
        if (this.selectedUser.pdToken) {
          localStorage.setItem('activeUser', JSON.stringify(this.selectedUser));
          console.log('默认设置activeUser:', this.selectedUser);
        }

        // 检查第一个用户的设置状态
        this.checkUserMassSetting(this.selectedUser.id).then(() => {
          // 设置默认激活的标签页（不重复加载数据）
          this.setDefaultActiveTabWithoutLoad();
        });
      }
    },

    // 设置默认激活的标签页
    setDefaultActiveTab() {
      // 默认选择消息标签页
      this.activeTab = 'message';

      // 设置默认标签页后加载对应的列表数据
      this.loadListData();
    },

    // 设置默认激活的标签页（不加载数据）
    setDefaultActiveTabWithoutLoad() {
      // 默认选择消息标签页
      this.activeTab = 'message';
    },

    // 检查用户群发设置状态
    async checkUserMassSetting(userId) {
      try {
        const response = await getUserIsMassSetting(userId);
        console.log('用户设置状态:', response);

        if (response && response.data) {
          const data = response.data;

          // 保存用户设置状态，包含所有字段
          this.userMassSetting = {
            message: data.message || false,
            mail: data.mail || false,
            messageJobId: data.messageJobId || null,
            mailJobId: data.mailJobId || null,
            // 消息相关设置
            messageIntervalTime: data.messageIntervalTime || 60,
            messageSendUserNum: data.messageSendUserNum || 20,
            messageUnSendUserTime: data.messageUnSendUserTime || 4,
            messageStatus: data.messageStatus || 1,
            // 邮件相关设置
            mailIntervalTime: data.mailIntervalTime || 360,
            mailSendUserNum: data.mailSendUserNum || 2,
            mailUnSendUserTime: data.mailUnSendUserTime || 6,
            mailStatus: data.mailStatus || 1,
          };

          // 记录设置状态
          if (data.message === false) {
            console.log('消息模板未设置');
          } else {
            console.log('消息模板已设置，JobId:', data.messageJobId);
          }

          if (data.mail === false) {
            console.log('邮件模板未设置');
          } else {
            console.log('邮件模板已设置，JobId:', data.mailJobId);
          }

          // 根据当前标签页获取列表数据
          this.loadListData();
        }
      } catch (error) {
        console.error('检查用户设置状态失败:', error);
        this.$message.error('检查用户设置状态失败');
      }
    },

    // 根据模板状态加载列表数据
    async loadListData() {
      if (!this.selectedUser.id) {
        this.clearListData();
        return;
      }

      const jobType = this.activeTab === 'message' ? 1 : 0; // 1:消息 0:邮件
      const hasTemplate =
        this.activeTab === 'message'
          ? this.userMassSetting.message
          : this.userMassSetting.mail;

      if (hasTemplate) {
        // 有模板，请求接口获取数据
        await this.fetchTaskTemplateData(jobType);
      } else {
        // 没有模板，清空列表数据
        this.clearListData();
      }
    },

    // 获取任务模板数据
    async fetchTaskTemplateData(jobType) {
      try {
        this.isLoadingTemplate = true; // 开始loading
        const data = {
          pageSize: 10,
          pageNum: 1,
        };

        const response = await getTaskTemplate(
          this.selectedUser.id,
          jobType,
          data
        );
        console.log('任务模板数据:', response);

        if (response && response.data) {
          // 根据当前标签页更新对应的列表
          if (this.activeTab === 'message') {
            this.messageList = this.formatTaskData(response.data);
          } else {
            this.emailList = this.formatTaskData(response.data);
          }
        } else {
          console.log('接口返回数据为空或格式不正确');
          this.clearListData();
        }
      } catch (error) {
        console.error('获取任务模板数据失败:', error);
        this.$message.error('获取任务模板数据失败');
        this.clearListData();
      } finally {
        this.isLoadingTemplate = false; // 结束loading
      }
    },

    // 格式化任务数据
    formatTaskData(data) {
      console.log('原始接口数据:', data);

      // 根据实际接口返回的数据结构进行格式化
      // 接口返回格式: { code: 200, msg: "success", data: { rows: [], total: number } }
      const list = data?.rows || data?.list || data || [];

      // 确保 list 是数组
      if (!Array.isArray(list)) {
        console.error('list 不是数组:', list);
        return [];
      }

      return list.map((item) => {
        console.log('处理单个任务项:', item);
        let imageList = [];
        let videoList = [];
        let attachmentsNum = 0;

        // 处理图片列表
        if (item.imagesUrl) {
          imageList = item.imagesUrl.split(',').filter((url) => url.trim());
        }

        // 处理视频列表
        if (item.videoUrl) {
          videoList = item.videoUrl.split(',').filter((url) => url.trim());
        }

        attachmentsNum = imageList.length + videoList.length;
        console.log('attachmentsNum::::::::::::', attachmentsNum);
        console.log('imageList::::::::::::', imageList);
        console.log('videoList::::::::::::', videoList);
        return {
          id: item.id || item.jobId || item.snailJobId,
          type: this.activeTab, // 'message' 或 'email'
          jobType: item.jobType, // 保留原始的 jobType 字段用于编辑
          contentType: 'text',
          content:
            item.messageContent || item.content || item.text || '暂无内容',
          sendInterval: item.intervalTime || item.sendInterval || 30,
          successCount: item.sendSuccesNum || 0,
          failCount: item.sendFailNum || 0,
          totalCount: item.sendNum || 0,
          countdown: item.countdown || 0,
          status: this.getStatusFromJobStatus(item),
          createTime:
            item.createTime || item.createDate || new Date().toLocaleString(),
          preSendTime: item.preSendTime,
          updateTime: item.updateTime,
          sendStatus: item.sendStatus,
          imageList,
          videoList,
          attachmentsNum,
          // 保留原始字段用于编辑
          imagesUrl: item.imagesUrl,
          imagesId: item.imagesId,
          videoUrl: item.videoUrl,
          videoId: item.videoId,
          messageContent: item.messageContent,
        };
      });
    },

    // 根据任务状态获取显示状态
    getStatusFromJobStatus(item) {
      // 根据实际接口返回的状态值进行映射
      //       {
      //     "createTime": "2025-08-27T08:47:59.000+00:00",
      //     "id": "1960625327280021506",
      //     "idUser": 69593048,
      //     "imagesId": "50551784",
      //     "imagesUrl": "https://i.gstatvb.com/shpzkl6gubotvmllu.r170x170.df74bd83.jpg",
      //     "intervalTime": 100,
      //     "jobId": 27,
      //     "jobType": 1,
      //     "messageContent": "测试123",
      //     "pdUserAccount": null,
      //     "preSendTime": "2025-08-27T10:27:59.000+00:00",
      //     "relevancyToken": null,
      //     "sendFailNum": 0,
      //     "sendNum": 1,
      //     "sendStatus": 0,
      //     "sendSuccesNum": 0,
      //     "sendTime": null,
      //     "sendUserId": null,
      //     "sendUserIds": null,
      //     "updateTime": null,
      //     "videoId": "",
      //     "videoUrl": ""
      // }

      const statusMap = {
        0: 'paused', // 暂停/未开始
        1: 'sending', // 运行中
        2: 'paused', // 暂停
        3: 'completed', // 完成
      };
      const jobStatus = item.sendStatus || item.status || item.jobStatus;
      const status = statusMap[jobStatus] || 'paused';
      console.log('映射后的状态:', status);
      return status;
    },

    // 清空列表数据
    clearListData() {
      if (this.activeTab === 'message') {
        this.messageList = [];
      } else {
        this.emailList = [];
      }
      // 清空选中的模板列表
      this.selectedTemplates = [];
    },

    // 检查邮件设置状态
    async checkEmailSetting() {
      try {
        const response = await getUserIsMassSetting(this.selectedUser.id);
        console.log('邮件设置状态:', response);

        if (response && response.data) {
          const { mail } = response.data;

          // 记录邮件设置状态
          if (mail === false) {
            this.$message.warning('邮件模板未设置');
          } else {
            this.$message.success('邮件模板已设置');
          }
        }
      } catch (error) {
        console.error('检查邮件设置状态失败:', error);
        this.$message.error('检查邮件设置状态失败');
      }
    },
    handleTabChange(tabKey) {
      this.activeTab = tabKey;
      // 切换标签页时清空选中的模板
      this.selectedTemplates = [];
      // 切换标签页时加载对应的列表数据
      this.loadListData();
    },

    // 获取创建按钮提示信息
    getCreateButtonTooltip() {
      if (!this.selectedUser.id) return '请先选择用户';

      const tabName = this.activeTab === 'message' ? '消息' : '邮件';
      if (this.canCreateContent) {
        return `创建${tabName}`;
      } else {
        return `请先设置${tabName}模板`;
      }
    },

    // 处理标签页右键点击事件
    async handleTabRightClick(tabKey, event) {
      event.preventDefault(); // 阻止默认右键菜单

      if (!this.selectedUser.id) {
        this.$message.warning('请先选择一个用户');
        return;
      }

      // 如果是邮件标签，检查邮件设置
      if (tabKey === 'email') {
        await this.checkEmailSetting();
      }
    },
    handleError(message) {
      this.$message.error(message);
    },
    handleCreateSuccess(response) {
      console.log('任务模板创建成功:', response);
      const contentType = response.type === 'message' ? '消息' : '邮件';
      this.$message.success(`${contentType}模板创建成功`);

      // 重新加载用户设置状态和列表数据
      if (this.selectedUser.id) {
        this.checkUserMassSetting(this.selectedUser.id);
      }
    },

    // 处理编辑成功
    handleEditSuccess(response) {
      console.log('任务模板编辑成功:', response);
      const contentType = response.type === 'message' ? '消息' : '邮件';
      this.$message.success(`${contentType}模板编辑成功`);

      // 重新加载用户设置状态和列表数据
      if (this.selectedUser.id) {
        this.checkUserMassSetting(this.selectedUser.id);
      }
    },

    // 处理设置成功
    handleSettingsSuccess(message) {
      this.$message.success(message);
      this.showSettingsModal = false;

      // 保存设置后重新检查用户设置状态
      if (this.selectedUser.id) {
        this.checkUserMassSetting(this.selectedUser.id);
      }
    },

    // 处理设置错误
    handleSettingsError(message) {
      this.$message.error(message);
    },

    // 启动倒计时定时器
    startCountdown() {
      this.countdownTimer = setInterval(() => {
        // 强制更新视图以刷新状态显示
        this.$forceUpdate();
      }, 1000);
    },
    // 格式化倒计时显示
    formatCountdown(seconds) {
      if (seconds <= 0) return '已完成';
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
    },

    // 获取状态显示文本
    getStatusDisplay(item) {
      const sendStatus = item.sendStatus;

      // 发送状态为0且有preSendTime值时，代表正在执行，需要倒计时
      if (sendStatus == 0 && item.preSendTime) {
        return this.getCountdownToExecute(
          item.preSendTime,
          item.intervalTime || item.sendInterval
        );
      }

      // 发送状态为0且没有preSendTime值时，代表未发送
      if (sendStatus == 0 && !item.preSendTime) {
        return '未发送';
      }

      // 发送状态为1时，代表发送完成
      if (sendStatus == 1) {
        return '发送完成';
      }

      // 如果sendStatus为2，说明没有满足发送条件的用户
      if (sendStatus == 2) {
        return '没有满足发送条件的用户';
      }

      // 其他情况显示默认状态
      return this.getStatusText(item.status);
    },

    // 计算倒计时到执行时间
    getCountdownToExecute(preSendTime, intervalTime) {
      // preSendTime: "2025-09-11T14:09:37.000+08:00"
      const now = new Date();
      const startTime = new Date(preSendTime);

      // 计算执行结束时间：preSendTime + intervalTime（分钟）
      let endTime = startTime;

      if (intervalTime && intervalTime > 0) {
        // intervalTime是分钟，转换为毫秒
        endTime = new Date(startTime.getTime() + intervalTime * 60 * 1000);
      }

      // console.log('调试信息:');
      // console.log('preSendTime:', preSendTime);
      // console.log('intervalTime:', intervalTime);
      // console.log('startTime:', startTime.toISOString());
      // console.log('endTime:', endTime.toISOString());
      // console.log('now:', now.toISOString());
      // console.log('startTime.getTime():', startTime.getTime());
      // console.log('endTime.getTime():', endTime.getTime());
      // console.log('now.getTime():', now.getTime());
      // console.log('intervalTime 类型:', typeof intervalTime);
      // console.log('intervalTime > 0:', intervalTime > 0);

      // 倒计时 = 结束时间 - 当前时间
      const diffMs = endTime - now;
      // console.log('diffMs:', diffMs);
      // console.log('diffMs (分钟):', Math.floor(diffMs / (1000 * 60)));
      // console.log('diffMs (小时):', Math.floor(diffMs / (1000 * 60 * 60)));

      if (diffMs <= 0) {
        // 当倒计时结束，显示发送完成
        return '发送完成';
      }

      const diffSeconds = Math.floor(diffMs / 1000);
      const hours = Math.floor(diffSeconds / 3600);
      const minutes = Math.floor((diffSeconds % 3600) / 60);
      const seconds = diffSeconds % 60;

      if (hours > 0) {
        return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds
          .toString()
          .padStart(2, '0')}`;
      } else {
        return `${minutes}:${seconds.toString().padStart(2, '0')}`;
      }
    },

    // 格式化中国时间
    formatChineseTime(timeString) {
      if (!timeString) return '';

      // 直接使用 toLocaleString 指定中国时区，避免手动计算时区偏移
      const date = new Date(timeString);
      // console.log('原始时间:', timeString);
      // console.log('解析后的Date对象:', date);

      return date.toLocaleString('zh-CN', {
        timeZone: 'Asia/Shanghai',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      });
    },
    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        sending: '发送中',
        completed: '已完成',
        paused: '已暂停',
      };
      return statusMap[status] || '未知';
    },
    // 获取发送状态文本
    getSendStatusText(sendStatus, preSendTime) {
      if (sendStatus === 0 && !preSendTime) {
        return '未发送';
      } else if (sendStatus === 0 && preSendTime) {
        return '发送中';
      } else if (sendStatus === 1) {
        return '发送完成';
      } else if (sendStatus === 2) {
        return '发送完成';
      }
      return '未知';
    },
    // 获取发送状态样式类
    getSendStatusClass(sendStatus, preSendTime) {
      if (sendStatus === 0 && !preSendTime) {
        return 'not-sent';
      } else if (sendStatus === 0 && preSendTime) {
        return 'sending';
      } else if (sendStatus === 1) {
        return 'sent';
      }
      return 'unknown';
    },
    // 判断是否为倒计时显示
    isCountdown(item) {
      const sendStatus = item.sendStatus;
      // 发送状态为0且有preSendTime值时，显示倒计时
      return sendStatus == 0 && item.preSendTime;
    },
    // 获取倒计时样式类
    getCountdownClass(item) {
      if (this.isCountdown(item)) {
        const countdownText = this.getStatusDisplay(item);
        // 如果倒计时小于5分钟，显示紧急样式
        if (
          countdownText.includes(':') &&
          !countdownText.includes('发送完成')
        ) {
          const parts = countdownText.split(':');
          if (parts.length === 2) {
            const minutes = parseInt(parts[0]);
            if (minutes < 5) {
              return 'countdown-urgent';
            }
          }
        }
        return 'countdown-active';
      }
      return '';
    },
    // 获取状态样式类
    getStatusClass(status) {
      const statusMap = {
        sending: 'status-sending',
        completed: 'status-completed',
        paused: 'status-paused',
      };
      return statusMap[status] || '';
    },
    // 获取内容类型文本
    getContentTypeText(contentType) {
      const typeMap = {
        text: '文本',
        image: '图片',
        video: '视频',
      };
      return typeMap[contentType] || '未知';
    },
    // 获取内容类型图标
    getContentTypeIcon(contentType) {
      const iconMap = {
        text: '📝',
        image: '🖼️',
        video: '🎥',
      };
      return iconMap[contentType] || '📄';
    },
    // 判断是否应该禁用编辑功能
    isEditDisabled(item) {
      // 发送状态为1或2表示发送完成，不可编辑
      if (item.sendStatus === 1 || item.sendStatus === 2) {
        return true;
      }

      // 如果倒计时已结束，也不可编辑
      if (item.sendStatus === 0 && item.preSendTime) {
        const now = new Date();
        const startTime = new Date(item.preSendTime);
        const intervalTime = item.intervalTime || item.sendInterval || 0;
        const endTime = new Date(startTime.getTime() + intervalTime * 60 * 1000);
        const diffMs = endTime - now;

        // 倒计时结束，不可编辑
        if (diffMs <= 0) {
          return true;
        }
      }

      return false;
    },

    // 显示编辑模态框
    openEditModal(item) {
      // 检查是否可编辑
      if (this.isEditDisabled(item)) {
        this.$message.warning('发送完成状态的任务不可编辑');
        return;
      }

      console.log('openEditModal::::::', item);
      // 使用解构赋值创建新对象，避免引用问题
      this.itemToEdit = { ...item };
      this.showEditModal = true;

      // 直接调用子组件的方法设置编辑数据
      this.$nextTick(() => {
        if (this.$refs.editModal) {
          this.$refs.editModal.setEditData(this.itemToEdit);
        }
      });
    },
    // 显示删除确认弹窗
    showDeleteConfirm(item) {
      this.itemToDelete = item;
      this.showDeleteModal = true;
    },
    // 关闭删除确认弹窗
    closeDeleteModal() {
      this.showDeleteModal = false;
      this.itemToDelete = null;
    },
    // 确认删除
    async confirmDelete() {
      if (this.itemToDelete && !this.isDeleting) {
        this.isDeleting = true; // 开始loading
        try {
          let jobId = null;
          if (this.activeTab === 'message') {
            jobId = this.userMassSetting.messageJobId;
          } else {
            jobId = this.userMassSetting.mailJobId;
          }
          // 调用删除接口
          await removeTaskTemplate(
            this.selectedUser.id,
            jobId,
            this.itemToDelete.id
          );

          // 从本地列表中移除
          if (this.activeTab === 'message') {
            this.messageList = this.messageList.filter(
              (msg) => msg.id !== this.itemToDelete.id
            );
          } else {
            this.emailList = this.emailList.filter(
              (email) => email.id !== this.itemToDelete.id
            );
          }

          this.$message.success('删除成功');
          this.closeDeleteModal();

          // 重新加载数据
          this.loadListData();
        } catch (error) {
          console.error('删除失败:', error);
          this.$message.error('删除失败，请重试');
        } finally {
          this.isDeleting = false; // 结束loading
        }
      }
    },

    // 选择列表项
    selectItem(item) {
      this.selectedItem = item.id;
      this.showDetail(item);
    },
    // 显示附件弹窗
    showAttachments(item) {
      this.selectItem(item);
      // console.log('showAttachments::::::', attachments);
      // this.currentAttachments = attachments;
      // this.showAttachmentModal = true;
    },
    // 关闭附件弹窗
    closeAttachmentModal() {
      this.showAttachmentModal = false;
      this.currentAttachments = [];
    },
    // 预览附件
    previewAttachment(attachment) {
      console.log('预览附件:', attachment);
      // 这里可以添加全屏预览功能
    },
    // 显示详情弹窗
    showDetail(item) {
      this.currentDetailItem = item;
      this.showDetailModal = true;
    },
    // 关闭详情弹窗
    closeDetailModal() {
      this.showDetailModal = false;
      this.currentDetailItem = null;
    },

    // 关闭白名单弹窗
    closeWhitelistModal() {
      this.showWhitelistModal = false;
    },

    // 处理选中用户ID变化
    handleSelectedUserIdsChange(selectedIds) {
      this.selectedUserIds = selectedIds;
    },

    // 处理选择变化
    handleSelectionChange(selectionData) {
      console.log('选择变化:', selectionData);
      this.selectedUserIds = selectionData.selectedIds;
    },

    // 处理批量设置成功
    handleBatchSettingsSuccess(message) {
      this.$message.success(message);
      this.showBatchSettingsModal = false;

      // 重新检查所有选中用户的设置状态
      this.refreshSelectedUsersSettings();
    },

    // 处理批量设置错误
    handleBatchSettingsError(message) {
      this.$message.error(message);
    },

    // 处理批量创建成功
    handleBatchCreateSuccess(message) {
      this.$message.success(message);
      this.showBatchCreateModal = false;

      // 重新检查所有选中用户的设置状态
      this.refreshSelectedUsersSettings();
    },

    // 处理批量创建错误
    handleBatchCreateError(message) {
      this.$message.error(message);
    },

    // 刷新选中用户的设置状态
    async refreshSelectedUsersSettings() {
      // 如果当前选中的用户在批量操作的用户列表中，重新检查其设置状态
      if (this.selectedUserIds.includes(this.selectedUser.id)) {
        await this.checkUserMassSetting(this.selectedUser.id);
      }
    },

    // 进入批量模式
    enterBatchMode() {
      this.isBatchMode = true;
      const selectUser = this.selectedUser;
      console.log('selectUser::::::', selectUser);
      this.selectedUserIds = [selectUser.id]; // 批量模式下，默认选中当前选中的用户
      // this.selectedUser = {}; // 清空当前选中的用户
    },

    // 退出批量模式
    exitBatchMode() {
      this.isBatchMode = false;
      this.selectedUserIds = []; // 清空已选择的用户
    },

    // 切换全选状态
    toggleSelectAll(event) {
      this.selectedTemplates = event.target.checked
        ? this.currentList.map((item) => item.id)
        : [];
    },

    // 切换单选状态
    toggleSelectTemplate(templateId) {
      if (this.selectedTemplates.includes(templateId)) {
        this.selectedTemplates = this.selectedTemplates.filter(
          (id) => id !== templateId
        );
      } else {
        this.selectedTemplates.push(templateId);
      }
    },

    // Element UI表格选择变化处理
    handleSelectionChange(selection) {
      this.selectedTemplates = selection.map(item => item.id);
    },

    // Element UI表格行类名
    getRowClassName({ row, rowIndex }) {
      let className = '';
      if (this.selectedItem === row.id) {
        className += 'active-row ';
      }
      const isSendCompleted =
        row.sendStatus === 1 || row.sendStatus === 2 || row.status === 'completed';
      if (isSendCompleted) {
        className += 'gray-row';
      }
      return className.trim();
    },

    // 显示批量删除确认弹窗
    showBatchDeleteConfirm() {
      this.showBatchDeleteModal = true;
    },

    // 关闭批量删除确认弹窗
    closeBatchDeleteModal() {
      this.showBatchDeleteModal = false;
    },

    // 确认批量删除
    async confirmBatchDelete() {
      if (this.selectedTemplates.length > 0 && !this.isBatchDeleting) {
        this.isBatchDeleting = true; // 开始loading
        try {
          let jobId = null;
          if (this.activeTab === 'message') {
            jobId = this.userMassSetting.messageJobId;
          } else {
            jobId = this.userMassSetting.mailJobId;
          }

          // 将ID数组转换为逗号拼接的字符串
          const templateIds = this.selectedTemplates.join(',');

          // 调用批量删除接口
          await removeTaskTemplate(this.selectedUser.id, jobId, templateIds);

          // 清空选中的模板列表
          this.selectedTemplates = [];

          this.$message.success('批量删除成功');
          this.closeBatchDeleteModal();

          // 重新加载数据
          this.loadListData();
        } catch (error) {
          console.error('批量删除失败:', error);
          this.$message.error('批量删除失败，请重试');
        } finally {
          this.isBatchDeleting = false; // 结束loading
        }
      }
    },
  },
};
</script>

<style scoped>
.news-feed-container {
  width: 100%;
  min-height: calc(100vh - 56px);
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  display: flex;
  flex-direction: column;
  font-family: 'PingFang SC', 'Microsoft YaHei', -apple-system,
    BlinkMacSystemFont, sans-serif;
}

/* 顶部导航栏 */
.top-navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 30px;
  background: rgba(255, 255, 255, 0.95);
  border-bottom: 1px solid rgba(229, 231, 235, 0.8);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  z-index: 100;
}

.nav-left {
  display: flex;
  gap: 15px;
}

.nav-icon {
  color: #6b7280;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.nav-icon:hover {
  color: #8b5cf6;
  background: rgba(139, 92, 246, 0.1);
  transform: translateY(-1px);
}

.nav-icon.active {
  color: #8b5cf6;
  background: rgba(139, 92, 246, 0.1);
}

.nav-center {
  flex: 1;
  display: flex;
  justify-content: center;
}

.connection-status {
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 13px;
  color: #4f46e5;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.2);
  animation: pulse 2s infinite;
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.8;
  }
}

.status-dot {
  width: 8px;
  height: 8px;
  background: #4f46e5;
  border-radius: 50%;
  animation: blink 1.5s infinite;
}

@keyframes blink {

  0%,
  50% {
    opacity: 1;
  }

  51%,
  100% {
    opacity: 0.3;
  }
}

.nav-right {
  display: flex;
  gap: 15px;
}

/* 主要内容区域 */
.main-content {
  display: flex;
  flex: 1;
  overflow: hidden;
}

/* 左侧用户选择 */
.user-sidebar {
  width: 300px;
  background: rgba(255, 255, 255, 0.8);
  border-right: 1px solid rgba(229, 231, 235, 0.8);
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.05);
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 20px;
  border-bottom: 1px solid rgba(229, 231, 235, 0.8);
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.sidebar-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.user-count {
  font-size: 13px;
  color: #6b7280;
  background: rgba(139, 92, 246, 0.1);
  padding: 4px 12px;
  border-radius: 12px;
  font-weight: 500;
}

.user-list {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

.user-item {
  display: flex;
  align-items: center;
  padding: 16px;
  margin-bottom: 12px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
  background: rgba(241, 245, 249, 0.8);
  position: relative;
  overflow: hidden;
}

.user-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg,
      transparent,
      rgba(255, 255, 255, 0.4),
      transparent);
  transition: left 0.5s;
}

.user-item:hover::before {
  left: 100%;
}

.user-item:hover {
  background: rgba(226, 232, 240, 0.9);
  border-color: rgba(139, 92, 246, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(139, 92, 246, 0.15);
}

.user-item.active {
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  color: white;
  border-color: #8b5cf6;
  box-shadow: 0 8px 25px rgba(139, 92, 246, 0.3);
  transform: translateY(-2px);
}

.user-item.active .user-nickname {
  color: white;
}

.user-item.active .user-id {
  color: rgba(255, 255, 255, 0.8);
}

.user-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 16px;
  border: 3px solid rgba(229, 231, 235, 0.8);
  position: relative;
  transition: all 0.3s ease;
}

.user-item.active .user-avatar {
  border-color: rgba(255, 255, 255, 0.8);
  transform: scale(1.1);
}

.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.user-item:hover .user-avatar img {
  transform: scale(1.1);
}

.status-indicator {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 14px;
  height: 14px;
  background: #10b981;
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  animation: pulse 2s infinite;
}

.user-info {
  flex: 1;
}

.user-nickname {
  font-weight: 700;
  font-size: 15px;
  color: #1f2937;
  margin-bottom: 4px;
  transition: color 0.3s ease;
}

.user-id {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
  transition: color 0.3s ease;
}

.user-actions {
  display: flex;
  align-items: center;
  margin-left: 15px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.user-item:hover .user-actions {
  opacity: 1;
}

.action-dot {
  width: 8px;
  height: 8px;
  background: #ef4444;
  border-radius: 50%;
  animation: pulse 1.5s infinite;
}

/* 右侧内容区域 */
.content-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.6);
  /* backdrop-filter: blur(10px); */
  height: calc(100vh - 60px);
  /* 固定高度，减去顶部导航栏高度 */
  overflow: hidden;
  /* 改为hidden，让内部元素控制滚动 */
}

.content-tabs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(229, 231, 235, 0.8);
  padding: 0 30px;
  background: rgba(255, 255, 255, 0.9);
}

.tabs-left {
  display: flex;
}

.tabs-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.tab-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 20px 24px;
  cursor: pointer;
  color: #6b7280;
  border-bottom: 3px solid transparent;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 600;
  font-size: 14px;
  position: relative;
}

.tab-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 3px;
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  transition: all 0.3s ease;
  transform: translateX(-50%);
}

.tab-item:hover {
  color: #8b5cf6;
  background: rgba(139, 92, 246, 0.05);
}

.tab-item.active {
  color: #8b5cf6;
}

.tab-item.active::after {
  width: 100%;
}

.tab-label {
  font-weight: 700;
}

.tab-count {
  background: rgba(139, 92, 246, 0.1);
  color: #8b5cf6;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.tab-item.active .tab-count {
  background: rgba(139, 92, 246, 0.2);
  color: #7c3aed;
}

.content-content {
  flex: 1;
  padding: 20px;
  height: calc(100vh - 140px);
  position: relative;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  min-width: 100px;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.btn-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease;
}

.btn-text {
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: transform 0.3s ease;
}

.btn-ripple {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.btn:active .btn-ripple {
  width: 300px;
  height: 300px;
}

.btn:hover .btn-icon-wrapper {
  transform: scale(1.1) rotate(5deg);
}

.btn:hover .btn-text {
  transform: translateX(2px);
}

.btn-primary {
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.3), 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-primary:hover {
  background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
  box-shadow: 0 8px 25px rgba(139, 92, 246, 0.4), 0 4px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.btn-primary:active {
  transform: translateY(0);
  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.3);
}

.btn-danger {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3), 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-danger:hover {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  box-shadow: 0 8px 25px rgba(239, 68, 68, 0.4), 0 4px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.btn-secondary {
  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(107, 114, 128, 0.3), 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-secondary:hover {
  background: linear-gradient(135deg, #4b5563 0%, #374151 100%);
  box-shadow: 0 8px 25px rgba(107, 114, 128, 0.4), 0 4px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.btn-secondary:active {
  transform: translateY(0);
  box-shadow: 0 4px 15px rgba(107, 114, 128, 0.3);
}

/* 创建按钮特殊样式 */
.create-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3), 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.create-btn:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%) !important;
  box-shadow: 0 8px 25px rgba(16, 185, 129, 0.4), 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}

.create-btn:active {
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3) !important;
}

.create-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%) !important;
  box-shadow: none !important;
}

.create-btn.disabled:hover {
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%) !important;
  box-shadow: none !important;
  transform: none;
}

.create-btn.disabled:active {
  box-shadow: none !important;
}

/* 设置按钮特殊样式 */
.settings-btn {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3), 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.settings-btn:hover {
  background: linear-gradient(135deg, #d97706 0%, #b45309 100%) !important;
  box-shadow: 0 8px 25px rgba(245, 158, 11, 0.4), 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}

.settings-btn:active {
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3) !important;
}

/* 按钮动画效果 */
@keyframes buttonPulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(1);
  }
}

.btn:hover {
  animation: buttonPulse 0.3s ease-in-out;
}

/* 图标旋转动画 */
@keyframes iconRotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.btn:hover .btn-icon-wrapper svg {
  animation: iconRotate 0.6s ease-in-out;
}

/* 按钮点击波纹效果 */
.btn:active .btn-ripple {
  animation: rippleEffect 0.6s ease-out;
}

@keyframes rippleEffect {
  0% {
    width: 0;
    height: 0;
    opacity: 1;
  }

  100% {
    width: 300px;
    height: 300px;
    opacity: 0;
  }
}

/* 滚动条样式 */
.user-list::-webkit-scrollbar,
.post-content::-webkit-scrollbar {
  width: 8px;
}

.user-list::-webkit-scrollbar-track,
.post-content::-webkit-scrollbar-track {
  background: rgba(241, 245, 249, 0.8);
  border-radius: 4px;
}

.user-list::-webkit-scrollbar-thumb,
.post-content::-webkit-scrollbar-thumb {
  background: rgba(139, 92, 246, 0.3);
  border-radius: 4px;
  transition: background 0.3s ease;
}

.user-list::-webkit-scrollbar-thumb:hover,
.post-content::-webkit-scrollbar-thumb:hover {
  background: rgba(139, 92, 246, 0.5);
}

/* 表格容器 */
.table-container {
  padding: 20px 0;
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
}

.data-table thead {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
}

.data-table th {
  padding: 16px 12px;
  text-align: left;
  font-weight: 600;
  font-size: 14px;
  color: white;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  white-space: nowrap;
}

.data-table tbody tr {
  border-bottom: 1px solid rgba(229, 231, 235, 0.5);
  transition: all 0.3s ease;
  cursor: pointer;
}

.data-table tbody tr:hover {
  background: rgba(139, 92, 246, 0.05);
}

.data-table tbody tr.active-row {
  background: rgba(139, 92, 246, 0.1);
  border-left: 3px solid #8b5cf6;
}

.data-table tbody tr.gray-row {
  background: rgba(107, 114, 128, 0.1);
  opacity: 0.7;
}

.data-table tbody tr.gray-row:hover {
  background: rgba(107, 114, 128, 0.15);
  opacity: 0.8;
}

.data-table td {
  padding: 12px;
  font-size: 14px;
  color: #374151;
  vertical-align: middle;
}

/* 单元格样式 */
.number-cell {
  width: 50px;
  text-align: left;
  font-weight: 600;
  color: #6b7280;
}

.content-cell {
  min-width: 400px;
  max-width: none;
}

.content-text {
  line-height: 1.4;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  box-orient: vertical;
  overflow: hidden;
}

.attachment-cell {
  width: 80px;
  text-align: center;
}

.attachment-count {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 4px 6px;
  background: rgba(139, 92, 246, 0.1);
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  color: #8b5cf6;
  cursor: pointer;
  transition: all 0.3s ease;
}

.attachment-count:hover {
  background: rgba(139, 92, 246, 0.2);
  transform: scale(1.05);
}

.attachment-icon {
  font-size: 14px;
  color: #8b5cf6;
}

.count-text {
  font-weight: 700;
}

.no-attachment {
  display: inline-block;
  padding: 4px 6px;
  background: rgba(107, 114, 128, 0.1);
  border-radius: 6px;
  font-size: 11px;
  color: #6b7280;
}

.no-attachment-text {
  font-weight: 500;
}

/* 图片预览列表样式 */
.attachment-images {
  cursor: pointer;
  transition: all 0.3s ease;
}

.attachment-images:hover {
  transform: scale(1.05);
}

.image-preview-list {
  display: flex;
  align-items: center;
  gap: 4px;
}

.image-preview-item {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  overflow: hidden;
  border: 2px solid rgba(139, 92, 246, 0.2);
  flex-shrink: 0;
}

.image-preview-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.3s ease;
}

.image-preview-item:hover img {
  transform: scale(1.1);
}

.image-preview-more {
  width: 32px;
  height: 32px;
  background: rgba(139, 92, 246, 0.1);
  border: 2px solid rgba(139, 92, 246, 0.2);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  color: #8b5cf6;
  flex-shrink: 0;
}

.speed-cell,
.interval-cell,
.sent-cell,
.fail-cell,
.success-cell {
  width: 60px;
  text-align: center;
}

.value-badge {
  display: inline-block;
  padding: 3px 6px;
  background: rgba(107, 114, 128, 0.1);
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  color: #374151;
  min-width: 25px;
  text-align: center;
}

.value-badge.success {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
}

.value-badge.fail {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.status-cell {
  width: 120px;
  text-align: left;
}

.countdown-display {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.countdown-timer {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background: linear-gradient(135deg,
      rgba(245, 158, 11, 0.1) 0%,
      rgba(217, 119, 6, 0.1) 100%);
  border: 1px solid rgba(245, 158, 11, 0.2);
  border-radius: 8px;
}

.countdown-icon {
  color: #f59e0b;
  font-size: 14px;
}

.countdown-text {
  font-weight: 700;
  color: #f59e0b;
  font-size: 13px;
  letter-spacing: 1px;
}

.countdown-display.countdown-urgent .countdown-timer {
  background: linear-gradient(135deg,
      rgba(239, 68, 68, 0.1) 0%,
      rgba(220, 38, 38, 0.1) 100%);
  border-color: rgba(239, 68, 68, 0.3);
}

.countdown-display.countdown-urgent .countdown-icon {
  color: #ef4444;
}

.countdown-display.countdown-urgent .countdown-text {
  color: #ef4444;
}

.send-status-cell {
  width: 80px;
  text-align: center;
}

.send-status-badge {
  display: inline-block;
  padding: 3px 6px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  min-width: 50px;
  transition: all 0.3s ease;
}

.send-status-badge.not-sent {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  border: 1px solid rgba(239, 68, 68, 0.2);
}

.send-status-badge.sending {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
  border: 1px solid rgba(59, 130, 246, 0.2);
}

.send-status-badge.sent {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
  border: 1px solid rgba(16, 185, 129, 0.2);
}

.send-status-badge.unknown {
  background: rgba(107, 114, 128, 0.1);
  color: #6b7280;
  border: 1px solid rgba(107, 114, 128, 0.2);
}

.actions-cell {
  width: 100px;
  text-align: center;
}

.action-buttons {
  display: flex;
  gap: 4px;
  justify-content: center;
}

.action-btn {
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.edit-btn {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
  margin-right: 8px;
}

.edit-btn i {
  font-size: 14px;
}

.edit-btn:hover:not(.disabled) {
  background: rgba(59, 130, 246, 0.2);
  transform: scale(1.1);
}

.edit-btn.disabled {
  background: rgba(107, 114, 128, 0.1) !important;
  color: #9ca3af !important;
  cursor: not-allowed !important;
  opacity: 0.6;
}

.edit-btn.disabled:hover {
  background: rgba(107, 114, 128, 0.1) !important;
  color: #9ca3af !important;
  transform: none !important;
}

.delete-btn {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.delete-btn i {
  font-size: 14px;
}

.delete-btn:hover {
  background: rgba(239, 68, 68, 0.2);
  transform: scale(1.1);
}

/* 附件弹窗样式 */
.attachment-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

.attachment-modal {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 800px;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.9);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(229, 231, 235, 0.8);
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.close-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  border-radius: 6px;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn i {
  font-size: 18px;
}

.close-btn:hover {
  background: rgba(239, 68, 68, 0.2);
  transform: scale(1.1);
}

.modal-content {
  padding: 24px;
  max-height: calc(80vh - 80px);
  overflow-y: auto;
}

.attachment-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
}

.attachment-item {
  border: 1px solid rgba(229, 231, 235, 0.8);
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.attachment-item:hover {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.attachment-preview {
  height: 150px;
  overflow: hidden;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.attachment-preview img,
.attachment-preview video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.attachment-preview img:hover,
.attachment-preview video:hover {
  transform: scale(1.05);
}

.attachment-name {
  padding: 12px;
  font-size: 12px;
  color: #374151;
  text-align: center;
  background: white;
  word-break: break-word;
  line-height: 1.4;
}

/* 删除确认弹窗样式 */
.delete-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

.delete-modal {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: modalSlideIn 0.3s ease-out;
}

.delete-content {
  padding: 32px;
  text-align: center;
}

.warning-icon {
  font-size: 48px;
  margin-bottom: 20px;
  color: #f59e0b;
}

.warning-icon i {
  font-size: 48px;
}

.delete-message {
  margin-bottom: 32px;
}

.delete-message p {
  margin: 0 0 12px 0;
  font-size: 16px;
  color: #374151;
  line-height: 1.5;
}

.content-preview {
  background: rgba(243, 244, 246, 0.8);
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  color: #6b7280;
  border-left: 3px solid #ef4444;
  text-align: left;
  word-break: break-word;
}

.delete-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.cancel-btn,
.confirm-btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 100px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

.cancel-btn {
  background: rgba(107, 114, 128, 0.1);
  color: #6b7280;
}

.cancel-btn:hover:not(:disabled) {
  background: rgba(107, 114, 128, 0.2);
  transform: translateY(-1px);
}

.cancel-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.confirm-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3);
}

.confirm-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4);
  transform: translateY(-1px);
}

.confirm-btn:disabled {
  background: linear-gradient(135deg, #fca5a5 0%, #ef4444 100%);
  opacity: 0.8;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.2);
}

.confirm-btn:disabled:hover {
  transform: none;
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.2);
}

.loading-spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* 可点击内容样式 */
.clickable {
  cursor: pointer;
  transition: all 0.3s ease;
}

.clickable:hover {
  color: #8b5cf6;
  text-decoration: underline;
}

/* 详情弹窗样式 */
.detail-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

.detail-modal {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 900px;
  max-height: 85vh;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: modalSlideIn 0.3s ease-out;
}

.detail-content {
  padding: 24px;
  max-height: calc(85vh - 80px);
  overflow-y: auto;
}

.detail-section {
  margin-bottom: 32px;
}

.detail-section:last-child {
  margin-bottom: 0;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  padding-bottom: 8px;
  border-bottom: 2px solid rgba(139, 92, 246, 0.2);
}

.section-title i {
  color: #8b5cf6;
  font-size: 18px;
}

.content-detail {
  background: rgba(248, 250, 252, 0.8);
  border-radius: 8px;
  padding: 16px;
  border-left: 3px solid #8b5cf6;
}

.content-text-full {
  color: #1f2937;
  line-height: 1.6;
  font-size: 14px;
  word-break: break-word;
  white-space: pre-wrap;
}

.attachment-detail {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  max-width: 100%;
}

.attachment-item-detail {
  border: 1px solid rgba(229, 231, 235, 0.8);
  border-radius: 8px;
  overflow: hidden;
  background: white;
  width: 100%;
}

.attachment-preview-detail {
  height: 200px;
  overflow: hidden;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.attachment-preview-detail img,
.attachment-preview-detail video {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* 附件分类样式 */
.attachment-section {
  margin-bottom: 24px;
}

.attachment-section:last-child {
  margin-bottom: 0;
}

.attachment-section-title {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 2px solid rgba(139, 92, 246, 0.1);
}

.attachment-section-title i {
  color: #8b5cf6;
  font-size: 18px;
}

/* 调度描述样式 */
.schedule-description {
  padding: 16px 20px;
  background: linear-gradient(135deg,
      rgba(139, 92, 246, 0.05) 0%,
      rgba(124, 58, 237, 0.05) 100%);
  border: 1px solid rgba(139, 92, 246, 0.1);
  border-radius: 12px;
  backdrop-filter: blur(10px);
  position: sticky;
  top: 0;
  z-index: 10;
  margin-bottom: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.description-text {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #374151;
  font-weight: 500;
  line-height: 1.5;
}

.description-text i {
  color: #8b5cf6;
  font-size: 16px;
}

.description-text.no-template {
  color: #f59e0b;
}

.description-text.no-template i {
  color: #f59e0b;
}

/* 空状态 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #9ca3af;
  text-align: center;
}

.empty-state svg {
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-state p {
  font-size: 16px;
  font-weight: 500;
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .user-sidebar {
    width: 250px;
  }

  .content-tabs {
    padding: 0 20px;
  }

  .tab-item {
    padding: 16px 16px;
    font-size: 13px;
  }

  .post-content {
    padding: 20px;
  }

  .post-card {
    padding: 24px;
  }

  /* 小屏幕下调整浮动位置 */
  .schedule-description {
    top: 0;
  }
}

@media (max-width: 480px) {
  .top-navbar {
    padding: 12px 20px;
  }

  .nav-left,
  .nav-right {
    gap: 10px;
  }

  .user-sidebar {
    width: 200px;
  }

  .sidebar-header {
    padding: 16px;
  }

  .user-item {
    padding: 12px;
  }

  .user-avatar {
    width: 40px;
    height: 40px;
    margin-right: 12px;
  }

  .post-header {
    flex-direction: column;
    gap: 16px;
  }

  .action-buttons {
    width: 100%;
    justify-content: space-between;
  }

  .post-images {
    flex-direction: column;
  }

  .image-container {
    max-width: 100%;
  }

  /* 超小屏幕下进一步调整浮动位置 */
  .schedule-description {
    top: 0;
    padding: 12px 16px;
  }
}

/* 批量操作按钮样式 */
.batch-actions {
  display: flex;
  gap: 12px;
  margin-right: 12px;
}

.batch-settings-btn {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3), 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.batch-settings-btn:hover {
  background: linear-gradient(135deg, #d97706 0%, #b45309 100%) !important;
  box-shadow: 0 8px 25px rgba(245, 158, 11, 0.4), 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}

.batch-settings-btn:active {
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3) !important;
}

.batch-create-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3), 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.batch-create-btn:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%) !important;
  box-shadow: 0 8px 25px rgba(16, 185, 129, 0.4), 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}

.batch-create-btn:active {
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3) !important;
}

/* 批量操作按钮禁用状态 */
.batch-settings-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%) !important;
  box-shadow: none !important;
}

.batch-settings-btn.disabled:hover {
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%) !important;
  box-shadow: none !important;
  transform: none;
}

.batch-settings-btn.disabled:active {
  box-shadow: none !important;
}

.batch-create-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%) !important;
  box-shadow: none !important;
}

.batch-create-btn.disabled:hover {
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%) !important;
  box-shadow: none !important;
  transform: none;
}

.batch-create-btn.disabled:active {
  box-shadow: none !important;
}

/* 批量模式按钮样式 */
.batch-mode-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;
  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3), 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.batch-mode-btn:hover {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;
  box-shadow: 0 8px 25px rgba(59, 130, 246, 0.4), 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}

.batch-mode-btn:active {
  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3) !important;
}

/* 退出批量模式按钮样式 */
.exit-batch-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3), 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.exit-batch-btn:hover {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%) !important;
  box-shadow: 0 8px 25px rgba(239, 68, 68, 0.4), 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}

.exit-batch-btn:active {
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3) !important;
}

/* 普通操作按钮容器 */
.normal-actions {
  display: flex;
  gap: 12px;
}

/* 白名单按钮样式 */
.whitelist-btn {
  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(107, 114, 128, 0.3);
}

.whitelist-btn:hover {
  background: linear-gradient(135deg, #4b5563 0%, #374151 100%);
  box-shadow: 0 6px 20px rgba(107, 114, 128, 0.4);
  transform: translateY(-1px);
}

.select-cell {
  width: 40px;
  text-align: center;
}

.interval-cell {
  width: 100px;
  text-align: center;
}

.interval-display {
  font-weight: 600;
}

/* 批量删除按钮样式 */
.batch-delete-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3), 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.batch-delete-btn:hover {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%) !important;
  box-shadow: 0 8px 25px rgba(239, 68, 68, 0.4), 0 4px 8px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-2px);
}

.batch-delete-btn:active {
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3) !important;
}

.batch-delete-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%) !important;
  box-shadow: none !important;
}

.batch-delete-btn.disabled:hover {
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%) !important;
  box-shadow: none !important;
  transform: none;
}

.batch-delete-btn.disabled:active {
  box-shadow: none !important;
}

/* 删除警告样式 */
.delete-warning {
  color: #ef4444;
  font-size: 14px;
  margin-top: 8px;
  font-weight: 600;
}

/* 选择单元格样式 */
.select-cell {
  width: 40px;
  text-align: center;
}

.select-cell input[type='checkbox'] {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

/* 间隔单元格样式 */
.interval-cell {
  width: 100px;
  text-align: center;
}

.interval-display {
  font-weight: 600;
}

/* 更精确的选择器 - 针对Element UI表格头 */
.el-table thead th {
  background: #1e293b !important;
  color: white !important;
  font-weight: 600 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.el-table thead th .cell {
  color: white !important;
  font-weight: 600 !important;
}

/* 针对表格头包装器 */
.el-table__header-wrapper {
  background: #1e293b !important;
}

.el-table__header-wrapper th {
  background: #1e293b !important;
  color: white !important;
  font-weight: 600 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.el-table__header-wrapper th .cell {
  color: white !important;
  font-weight: 600 !important;
}

/* 使用深度选择器穿透scoped样式 */
::v-deep .el-table thead th {
  background: #1f314e !important;
  color: white !important;
  font-weight: 600 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}

::v-deep .el-table thead th .cell {
  color: white !important;
  font-weight: 600 !important;
}

::v-deep .el-table__header-wrapper {
  background: #1e293b !important;
}

/* 修复勾选框样式与表头一致 */
::v-deep .el-table thead th .el-checkbox {
  color: white !important;
}

::v-deep .el-table thead th .el-checkbox__input {
  color: white !important;
}

::v-deep .el-table thead th .el-checkbox__inner {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

::v-deep .el-table thead th .el-checkbox__inner:hover {
  border-color: rgba(255, 255, 255, 0.5) !important;
}

::v-deep .el-table thead th .el-checkbox__inner::after {
  border-color: white !important;
}

::v-deep .el-table thead th .el-checkbox.is-checked .el-checkbox__inner {
  background-color: #8b5cf6 !important;
  border-color: #8b5cf6 !important;
}

::v-deep .el-table thead th .el-checkbox.is-indeterminate .el-checkbox__inner {
  background-color: #8b5cf6 !important;
  border-color: #8b5cf6 !important;
}

::v-deep .el-table thead th .el-checkbox.is-indeterminate .el-checkbox__inner::before {
  background-color: white !important;
}

/* 表格行勾选框样式 */
::v-deep .el-table tbody td .el-checkbox__inner {
  background-color: rgba(255, 255, 255, 0.9) !important;
  border-color: rgba(139, 92, 246, 0.3) !important;
}

::v-deep .el-table tbody td .el-checkbox__inner:hover {
  border-color: #8b5cf6 !important;
}

::v-deep .el-table tbody td .el-checkbox.is-checked .el-checkbox__inner {
  background-color: #8b5cf6 !important;
  border-color: #8b5cf6 !important;
}

::v-deep .el-table tbody td .el-checkbox.is-checked .el-checkbox__inner::after {
  border-color: white !important;
}

/* 发送完成行置灰 */
::v-deep .el-table__body tr.gray-row {
  background: rgba(107, 114, 128, 0.12);
  color: #9ca3af;
}

/* ::v-deep .el-table__body tr.gray-row:hover {
  background: rgba(107, 114, 128, 0.18);
} */

::v-deep .el-table__body tr.gray-row .cell {
  color: #9ca3af;
}
</style>
